import { DealerPanelContentGroup } from '@/components/sections/dealer/panel/content/group';
import { DealerPanelContentGroupDataRowLabelValue } from '@/components/sections/dealer/panel/content/group/data-row-label-value';
import { DealerPanelContentLabelWithIcon } from '@/components/sections/dealer/panel/content/label-with-icon';
import { Link } from '@/components/shared/element/link';
import { IDealerSale } from '@/types/dealer/dealer';

interface DealerPanelContentGroupContact {
  dealerSale: IDealerSale;
}

export const DealerPanelContentGroupContact = ({
  dealerSale,
}: DealerPanelContentGroupContact) => {
  return (
    <DealerPanelContentGroup>
      {!!dealerSale.website && (
        <DealerPanelContentGroupDataRowLabelValue
          label="เว็บไซต์"
          labelIcon="globe"
        >
          <Link
            href={dealerSale.website}
            target="_blank"
            test={{
              dataTest: 'contact-dealer',
            }}
            tracking={{
              dataTrack: 'contact-dealer',
              dataTrackText: `website`,
              dataTrackUrl: dealerSale.website,
              dataTrackValue: dealerSale.website,
            }}
          >
            <DealerPanelContentLabelWithIcon
              icon="pickup"
              label={dealerSale.website}
              isLink
            />
          </Link>
        </DealerPanelContentGroupDataRowLabelValue>
      )}
      {!!(dealerSale.fb_sale_cv || dealerSale.fb_sale_lcv) && (
        <DealerPanelContentGroupDataRowLabelValue
          label="Facebook"
          labelIcon="facebook"
        >
          {!!dealerSale.fb_sale_lcv && (
            <Link
              href={`https://www.facebook.com/${dealerSale.fb_sale_lcv}`}
              test={{
                dataTest: 'contact-dealer',
              }}
              tracking={{
                dataTrack: 'contact-dealer',
                dataTrackText: `lcv_facebook_page`,
                dataTrackUrl: `https://www.facebook.com/${dealerSale.fb_sale_lcv}`,
                dataTrackValue: dealerSale.fb_sale_lcv,
              }}
            >
              <DealerPanelContentLabelWithIcon
                icon="pickup"
                label={dealerSale.fb_sale_lcv}
                isLink
              />
            </Link>
          )}
          {!!dealerSale.fb_sale_cv && (
            <Link
              href={`https://www.facebook.com/${dealerSale.fb_sale_cv}`}
              test={{
                dataTest: 'contact-dealer',
              }}
              tracking={{
                dataTrack: 'contact-dealer',
                dataTrackText: `cv_facebook_page`,
                dataTrackUrl: `https://www.facebook.com/${dealerSale.fb_sale_cv}`,
                dataTrackValue: dealerSale.fb_sale_cv,
              }}
            >
              <DealerPanelContentLabelWithIcon
                icon="truck"
                label={dealerSale.fb_sale_cv}
                isLink
              />
            </Link>
          )}
        </DealerPanelContentGroupDataRowLabelValue>
      )}
    </DealerPanelContentGroup>
  );
};

DealerPanelContentGroupContact.displayName =
  'SectionDealerPanelContentGroupContact';
